import React, { useState } from 'react';
import { Loader2, Send } from 'lucide-react';
import { toast } from 'sonner';
import { Card, inputCls, goldBtn } from '../ui';
import { api, eur, errMsg } from '../api';

export default function MortgageForm({ enabled, price, onDone }) {
  const [form, setForm] = useState({ name: '', code: '' });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post('/property/mortgage', form);
      toast.success('Ispezione ipotecaria richiesta: la ricerca nazionale è partita');
      setForm({ name: '', code: '' });
      onDone();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Card className="p-6 mb-6" data-testid="mortgage-request-form">
      <p className="text-[11px] uppercase tracking-[0.18em] text-[#5A5F67] mb-4">Richiedi ispezione ipotecaria nazionale · persona fisica</p>
      <form onSubmit={submit} className="grid gap-3 md:grid-cols-[1.4fr_1fr_auto] items-end">
        <input className={`${inputCls} w-full px-3 border`} placeholder="Nome e cognome" value={form.name} onChange={set('name')} required minLength={2} data-testid="mortgage-name-input" />
        <input className={`${inputCls} w-full px-3 border font-mono uppercase`} placeholder="Codice fiscale (16 caratteri)" value={form.code} onChange={set('code')} required data-testid="mortgage-code-input" />
        <button type="submit" disabled={!enabled || busy} className={`${goldBtn} h-11 px-5 inline-flex items-center justify-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed`} data-testid="mortgage-request-btn">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Send size={15} />}
          {enabled ? `Richiedi${price != null ? ` · ${eur(price)}` : ''}` : 'In attivazione'}
        </button>
      </form>
      <p className="text-xs text-[#5A5F67] mt-3">1. Ricerca nazionale: trovi le conservatorie in cui il soggetto compare. 2. Scegli le conservatorie e ricevi l'elenco sintetico delle formalità (ipoteche, pignoramenti, compravendite). 3. Scegli le note da aprire. Ti avvisiamo via email e con notifica nell'app a ogni passaggio. Escluse le zone con sistema tavolare (Trento, Bolzano, Trieste, Gorizia).</p>
    </Card>
  );
}
